module.exports = __webpack_public_path__ + "img/200603.3ef4d85f.png";